import styled from 'styled-components'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'

export const StyledEmptyNotificationWrapper = styled(Flexbox)(
    ({theme: {spacing}}) => `
        padding: ${spacing * 6}px 0;
        min-height: 200px;
    `
)
